import { Component, input } from '@angular/core';

@Component({
  selector: 'app-overlay',
  templateUrl: './overlay.component.html',
  styleUrl: './overlay.component.scss',
  standalone: true,
})
export class OverlayComponent {
  readonly message = input.required<string>();
}
